import {SupportTriggerPointTriggerPoint} from '../../../generated/types';

const AssistantTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
  'payments_analytics',
];

const StartFreshTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
  'payments_analytics',
];

const RestartableTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_drawer_internal',
  'dashboard_help_menu_contact_support',
  'dashboard_help_icon',
  'dashboard_mobile_ios_app_get_help',
  'support_site_contact_support_link',
  'support_site_contact_url',
  'support_site_contact_us_link',
  'support_site_content',
  'support_site_i_cant_sign_in',
];

export function isAssistantTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    AssistantTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}

export function isDotComCsfTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return !!triggerPoint && triggerPoint === 'dot_com_embedded_csf';
}

export function isDotComCsfSelfServeRedirectTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return !!triggerPoint && triggerPoint === 'dot_com_embedded_csf_self_serve';
}

export function isStartFreshTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    StartFreshTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}

export function isRestartableTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    RestartableTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}
